import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20 13a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20 7c-4.818 0-9.12 2.324-12.831 5.976A31.382 31.382 0 0 0 3.802 16.9l-.006.009-.394.554-.006.009c-.249.358-.455.672-.617.932l-.004.006-.203.336L1.844 20l.728 1.254.203.336.004.006c.162.26.368.573.617.932l.006.01.394.553.006.009a31.382 31.382 0 0 0 3.367 3.923C10.88 30.676 15.182 33 20 33s9.12-2.324 12.831-5.977a31.38 31.38 0 0 0 3.367-3.923l.007-.009.393-.554.006-.009c.372-.536.65-.975.829-1.282L38.157 20l-.729-1.254-.203-.336-.004-.006a23.72 23.72 0 0 0-.617-.932l-.006-.01-.393-.553-.007-.009a31.38 31.38 0 0 0-3.367-3.923C29.12 9.323 24.819 7 20.002 7ZM8.572 14.402C12.047 10.982 15.872 9 20 9c4.127 0 7.953 1.982 11.429 5.402a29.374 29.374 0 0 1 3.148 3.669l.387.545c.23.33.415.614.557.841l.187.309.136.234-.14.242c-.145.248-.392.64-.74 1.142l-.387.545a29.383 29.383 0 0 1-3.148 3.669C27.953 29.018 24.127 31 20 31c-4.127 0-7.953-1.982-11.428-5.402a29.375 29.375 0 0 1-3.149-3.669l-.387-.545a21.68 21.68 0 0 1-.557-.841l-.186-.309L4.157 20l.136-.234.186-.309c.142-.227.328-.51.557-.841l.387-.545a29.382 29.382 0 0 1 3.149-3.669Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramValuationViews40 = createIcon(IconComponent);